module.exports = __webpack_public_path__ + "img/home-shebei-4.cc99c69e.png";